export const openGraph = {
  siteName: 'ikwaibulldog',
  ogType: 'website',
  twitterCardType: 'summary_large_image',
  useAppLink: false,
  fbAppId: '1301198813362609',
  indexScheme: 'ikwaibulldog://home',
  packageName: 'com.kwai.bulldog',
  packageUrl: 'https://play.google.com/store/apps/details?id=com.kwai.bulldog',
  appId: '1521114100',
  appName: 'Snack Video',
  androidAppForGoogle: 'android-app://com.kwai.bulldog/ikwaibulldog/home',
  iosAppForGoogle: 'ios-app://1521114100/ikwaibulldog/home',
};
